import * as core from '../../../../../../../core'

import { query } from './planning-epics-table.query'

export const RESOURCE = {
  payload: {
    alias: 'planning.epics.table',
    description: 'Table view of the Jira epics planned for this engagement',
    name: 'Planning Epics Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
